import { render } from "./TasksPage.vue?vue&type=template&id=5498009c&scoped=true&ts=true"
import script from "./TasksPage.vue?vue&type=script&lang=ts"
export * from "./TasksPage.vue?vue&type=script&lang=ts"

import "./TasksPage.vue?vue&type=style&index=0&id=5498009c&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5498009c"]])

export default __exports__